import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export interface UpdateRegistrationGradesRequest {
  attended?: boolean | null;
  internalGrade?: number | null;
  externalGrade?: number | null;
  finalGrade?: number | null;
}

export const updateRegistrationGradesOperation = async (
  groupId: number,
  examId: number,
  registrationId: number,
  request: UpdateRegistrationGradesRequest,
  setRegistrationId: (registrationId: number | null) => any,
  onSuccess: () => void,
) => {
  try {
    setRegistrationId(registrationId);

    const res = await appApi.updateExternalExamRegistrationGrades(
      groupId,
      examId,
      registrationId,
      request,
    );

    if (res.data.ok) {
      toast.success('עדכון נתונים בוצע בהצלחה');
      onSuccess();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      toast.error('עדכון נתונים נכשל, נסה שוב בעוד מספר רגעים...');
    }

    setRegistrationId(null);
  } catch (e) {
    toast.error('עדכון נתונים נכשל, נסה שוב בעוד מספר רגעים...');
    console.error(
      `updateRegistrationGradesOperation failed for registrationId: ${registrationId} with error: ${e}`,
    );
    setRegistrationId(null);
  }
};
